import * as bankBillet from "./bankBillet";
import * as charge from "./charge";
import * as configuration from "./configuration";
import * as das from "./das";
import * as invoice from "./invoice";
import * as dasn from "./dasn";
import * as login from "./login";
import * as mei from "./mei";
import * as company from "./company";
import * as nfse from "./nfse";
import * as paymentMethod from "./paymentMethod";
import * as plan from "./plan";
import * as subscription from "./subscription";
import * as transfer from "./transfer";
import * as user from "./user";
import * as authToken from "./authToken";
import * as emails from "./emails";
import * as dashboard from "./home";

export default {
	bankBillet,
	charge,
	configuration,
	das,
	invoice,
	dasn,
	login,
	mei,
	company,
	nfse,
	paymentMethod,
	plan,
	subscription,
	transfer,
	user,
	authToken,
	emails,
	dashboard

};
